import Axios from 'axios';

import { message } from 'ant-design-vue';
import 'ant-design-vue/es/message/style/css';
const axios = Axios.create({
  // baseURL: 'https://affine.rockstime.com',
  // baseURL: 'http://192.168.31.215:8080',
  // baseURL: 'http://affine.machao.group',
  baseURL: 'https://106.55.9.16:8386',
  timeout: 200000, // 请求超时 20s
  withCredentials: true,
  headers: { withcredentials:true },
});

// 前置拦截器（发起请求之前的拦截）
axios.interceptors.request.use(
  (response) => {
    /**
     * 根据你的项目实际情况来对 config 做处理
     * 这里对 config 不做任何处理，直接返回
     */
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 后置拦截器（获取到响应时的拦截）
axios.interceptors.response.use(
  (response) => {
    /**
     * 根据你的项目实际情况来对 response 和 error 做处理
     * 这里对 response 和 error 不做任何处理，直接返回
     */

    return response.data;
  },
  (error) => {
    if (error.response && error.response.data) {
      const code = error.response.status;
      const msg = error.response.data.message;
      //   ElMessage.error(`Code: ${code}, Message: ${msg}`)
      message.error(`Code: ${code}, Message: ${msg}`);
      console.error(`[Axios Error]`, error.response);
    } else {
      //   ElMessage.error(`${error}`)
      message.error(`${error}`);
    }
    return Promise.reject(error);
  }
);

export default axios;
